import EventBus from "./event-bus";

const axios = require('axios');
import {errorHandler} from "./common";
import {setPdfView} from "./utils";
export function getRequest(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/request?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}

export function deleteRequest(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/request?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function generateRequestHbNo(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/request/assign/hbno?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateRequest(request) {
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/request', JSON.stringify(request),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateRequests(requests) {
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/requests', JSON.stringify(requests),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getRequestsByState(stateFrom, stateTo) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests?stateFrom=' + stateFrom + "&stateTo=" + stateTo,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getRequestsForCalendar(from, to) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests/calendar?from=' + from + "&to=" + to,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getRequestsWaiting(from, to) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests/waiting',  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getRequestsByTime(createdFrom, createdTo) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests?createdFrom=' + createdFrom + "&createdTo=" + createdTo,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}

export function getRequestsByName(name) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests?searchName='+ name,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function searchRequests(query) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/requests?'+ query,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function sendEmailToCustomer(emailItem) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/request/email', JSON.stringify(emailItem),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function sendEmailLinkToCustomer(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/request/customer/info/email?id=' + id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getRequestPDF(id) {
  let axiosConfig = {
    method: 'get',
    responseType: 'blob',
    url: process.env.ROOT_API + 'admin/request/pdf?id='+id,
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}
export function generateRequestSurveyForm(id) {
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/request/' + id + '/generate/surveyform',  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function getPackingListExcel(id) {
  let axiosConfig = {
    method: 'get',
    responseType: 'blob',
    url:process.env.ROOT_API + 'admin/packingInvoice/' + id + '/excel',
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}

export function downloadExcel(url) {
  let axiosConfig = {
    method: 'get',
    responseType: 'blob',
    url:url
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}
export function getStateList() {
  let list = [
    {
      title: '신규',
      value: 0,
    },
    {
      title: '접수',
      value: 1,
    },
    {
      title: '상담 완료',
      value: 10,
    },
    {
      title: '방문견적 완료',
      value: 20,
    },
    {
      title: '이사날짜 완료',
      value: 30,
    },
    {
      title: '선적 완료',
      value: 50,
    },
    {
      title: '도착지 배송 완료',
      value: 100,
    },
    {
      title: '취소',
      value: -100,
    },

  ];
  return list;
}
export function convertState(state) {
  if(state == 0) {
    return '요청 접수';
  } else if(state == 1) {
    return '요청 접수';
  } else if(state == 10) {
    return '상담 완료';
  } else if(state == 3) {
    return '픽업 예정';
  } else if(state == 4) {
    return '픽업 완료';
  } else if(state == 5) {
    return '운송 대기';
  } else if(state == 6) {
    return '운송중';
  } else if(state == 7) {
    return '도착';
  } else if(state == 8) {
    return '세관통과';
  } else if(state == 9) {
    return '이동중';
  } else if(state == 10) {
    return '도착 완료';
  }
  return 'Unknown(' + state + ')';
}
export function moveTypeString(type) {
  if(type === 'korea') {
    return '귀국';
  } else if(type === 'uk') {
    return '영국';
  } else if(type === 'world') {
    return '3국';
  }
  return type;
}
export function getShippingMode() {
  let list = ['SEA OUT', 'SEA IN', 'AIR OUT', 'AIR IN', 'EURO LAND', 'DOMESTIC'];
  return list;
}
export function getItemTypeList() {
  let list = [
    {
      title:'Ocean Export',
      value:'Ocean Export'
    },
    {
      title:'Ocean Import',
      value:'Ocean Import'
    },
    {
      title:'Air Export',
      value:'Air Export'
    },
    {
      title:'Air Import',
      value:'Air Import'
    },
    {
      title:'Domestic',
      value:'Domestic'
    },
    {
      title:'DEL',
      value:'DEL'
    },
    {
      title:'EX',
      value:'EX'
    },

  ];
  return list;

}
export function getParkingValues() {
  let list = [
    {
      title:'Select',
      value:-1,
    },
    {
      title:'Parking OK',
      value:0,
    },
    {
      title:'Parking Unavailable',
      value:1,
    },
    {
      title:'Parking Suspension',
      value:2,
    }
  ];
  return list;
}
export function getStaff() {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/staffs?type=all';

    console.log("worker list " + url);
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getJobLinkers(itemId) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/joblinkers?itemId=' + itemId;

    console.log("worker list " + url);
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateJobLinker(jobLinker) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/joblinker', JSON.stringify(jobLinker),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function deleteJobLinker(id) {
  return new Promise(function(resolve, reject) {
    axios.delete(process.env.ROOT_API + 'admin/joblinker?id='+ id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function createNewJob(requestId, user) {
  let item = {
    id:0,
    requestId:requestId,
    userId:user.id,
    // user:JSON.parse(JSON.stringify(user)),
  };
  return item;
}
export function requestMethodList() {
  let list = [
    '방문접수', '전화접수'
  ];
  return list;
}
export function createNewRequest() {
  let item = {
    id:0,
    account:'',
    requestMethod:'',
    visitDate:'',
    visitHour:0,
    visitMin:0,
    requestType:'',
    shippingMode:'',
    requester:'',
    companyName:'',
    headCount:1,
    phoneNumber:'',
    email:'',
    countryFrom:'UK',
    addressFrom:'',
    countryTo:'대한민국',
    addressTo:'',
    expectedMoveDate:'',
    state:0,
    reference:'',
    list:false,
    parking:0,
    packingDate:'',
    packingDateConfirmed:false,
    cntr:false,
    leavingDate:'',
    note:'',
    instruction:'',
    estimatedPrice:0,
    price:0,
    images:[],
    documents:[],
    items:[],
    preparations:[],
    assignees:[],
    contractors:[],
    cubes:1,
    vehicles:'',
    qty:0,
    kg:0,
    dcDo:0,
    dcStr:0,
    dcIns:0,
    dcLift:0,
    dcDelivery:0,
    dcFullSet:0,
    cr:0,
    dr:0,
    cbm:0,
    cbmFloat:0.0,
    preCbm:0,
    hbNo:'',
    remark:'',
    tags:'',
    parkingImage:'',
    destinationTel:'',
    urnCode:'',
    containerNumber: '',
    sealNumber:'',
    loadingDate:'',
    containerSize:0,
    remarkFull:'',
    memo:'',
    taxiRequired:false,
    taxiInfo:'',
    packingListDoc:'',
    surveyForm:'',
    packingInvoice:'',
    approvalLetter:'',
    psid:'',
    commercialInvoice:'',
    tncAgreement:'',
    reasonStatement:'',
    packingInvoiceItem:null,
  };
  return item;

}

export function updatePackingInvoice(item) {
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios.post(process.env.ROOT_API + 'admin/packingInvoice', JSON.stringify(item),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getPackingInvoice(id) {
  return new Promise(function(resolve, reject) {
    axios.get(process.env.ROOT_API + 'admin/packingInvoice/'+ id,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      errorHandler(err);
      reject(err);
    })
  })
}
export function getPackingInvoicePDF(id) {
  let axiosConfig = {
    method: 'get',
    url: process.env.ROOT_API + 'admin/packingInvoice/' + id + '/pdf',
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response.data);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}
export function generatePerformanceReportPDF(id) {
  return new Promise(function(resolve, reject) {
    let axiosConfig = {
      method: 'get',
      responseType: 'blob',
      url: process.env.ROOT_API + 'admin/request/'+ id + '/performance/report',
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    };
    EventBus.$emit("showLoading", true);
    return new Promise(function(resolve, reject) {
      axios( axiosConfig).then(function(response) {
        EventBus.$emit("showLoading", false);
        setPdfView(response.data);
      }).catch(function(error) {
        EventBus.$emit("showLoading", false);
        errorHandler(error);
        reject(error)
      });
    })

  })
}
export function createNewPackingInvoice(request) {
  let item = {
    id:0,
    requestId: request.id,
    invoiceDate:'',
    urnCode:request.urnCode,
    shipper:request.requester,
    shipperAddress1:request.addressFrom,
    shipperAddress2:'',

    consignee:'',
    consigneeAddress1:request.addressTo,
    consigneeAddress2:'',
    consigneeTel:request.destinationTel,

    notifyParty:'SAME AS CONSIGNEE',
    notifyPartyAddress:'',
    notifyPartyTel:'',
    notifyPartyEmail:'',

    remarks:'',
    incoTerms:'FOB',
    freightCharge:0,
    freightChargeFloat:0.00,

    pol:'',
    finalDestination:'',
    vessel:'',

    goods:[],

    numberOfPackages:0,
    netWeight:0,
    netWeightFloat:0.00,
    grossWeight:0,
    grossWeightFloat:0.00,
    totalPrice:0,
    totalPriceFloat:0.00,

    hsCode: '9905000000',
    signedBy:'',
    reference:'',



  }

  return item;

}



// WEBPACK FOOTER //
// ./src/api/request.js